// extracted by mini-css-extract-plugin
export var optionGrid = "_74-7";
export var optionList = "_74-6";
export var questionsBlock = "_74-9";
export var spacer = "_74-5";
export var stepCenteredContent = "_74-3";
export var stepInner = "_74-0";
export var stepInnerFullWidth = "_74-1";
export var stepInnerLockScroll = "_74-2";
export var stepTransitionFrame = "_74-4";
export var welcomeBlock = "_74-8";